export default "dist/furniture/key.png";